// endpoints
import * as mechanicEndPoints from "../constants/endpoints/mechanic";
// axios
import axios from "../axios/axios";

export const getMechanicsList = () => {
  return axios({
    url: mechanicEndPoints.getMechanicsList,
    method: "GET",
  });
};

export const getAllMechanicCollections = (mechanicId) => {
  return axios({
    url: `${mechanicEndPoints.getAllMechanicCollections}/${mechanicId}`,
    method: "GET",
  });
};
